import { render, staticRenderFns } from "./checkBox.vue?vue&type=template&id=28d23a0a&scoped=true&"
import script from "./checkBox.vue?vue&type=script&lang=js&"
export * from "./checkBox.vue?vue&type=script&lang=js&"
import style0 from "./checkBox.vue?vue&type=style&index=0&id=28d23a0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d23a0a",
  null
  
)

export default component.exports